export const  products = [
    { id: 1, label: "ACERBO SC" },
    { id: 2, label: "ADMIRE WG" },
    { id: 3, label: "ADORA SC" },
    { id: 4, label: "ADUE" },
    { id: 5, label: "ALANTO SC" },
    { id: 6, label: "ALION PLUS SC" },
    { id: 7, label: "ALL ROUNDER" },
    { id: 8, label: "AMBITION" },
  ];

  export const  districts = [
    { id: 1, label: "District 1" },
    { id: 2, label: "District 2" },
    { id: 3, label: "District 3" },
    { id: 4, label: "District 4" },
    { id: 5, label: "District 5" },
    { id: 6, label: "District 6" },
    { id: 7, label: "District 7" },
    { id: 8, label: "District 8" },
  ];


  export const myRequests = [
    {
      request_id: '23404',
      partner_id: '123456789',
      govt_application_number: "GOVT3456787654456",
      gst_number: "98765434567898765432",
      license_number: "LPC98765456789",
      license_issued_date: "2025-07-06",
      license_expiry_date: "2025-07-06",
      license_copy_url: "http://www.dj.com/doc/345678",
      shop_address: "#4, kormangala, 5th block, saa dreams layout",
      shop_district: "bengaluru",
      shop_pincode: "123456789098765",
      godown_same_as_shop: true,
      godown_address: "#4, kormangala, 5th block, saa dreams layout, HBR Layout, Bengaluru, Karnataka",
      godown_district: "Bengaluru",
      godown_pincode: "234565432345",
      assigned_to: "43421",
      deliveryCode:'9876',
      due_date: "12th Mar 2025",
      products: [
        "BCALB0021",
        "NACAL9876"
      ],
      status: [
        {
          info: 'Request Submitted',
          status: 'completed',
          last_updated : '2025-07-06',
        },
        {
          info: 'Under Review',
          status: 'active',
          last_updated : '2025-07-07',
        },
        {
          info: 'Completed/Rejected',
          status: 'pending',
          last_updated : '',
        }
      ],
      remarks: "string"
    },
    {
      request_id: '12022',
      partner_id: '123456789',
      govt_application_number: "GOVT3456787654456",
      gst_number: "98765434567898765432",
      license_number: "LPC98765456789",
      license_issued_date: "2025-07-06",
      license_expiry_date: "2025-07-06",
      license_copy_url: "http://www.dj.com/doc/345678",
      shop_address: "#4, kormangala, 5th block, saa dreams layout",
      shop_district: "bengaluru",
      shop_pincode: "123456789098765",
      godown_same_as_shop: true,
      godown_address: "#4, kormangala, 5th block, saa dreams layout",
      godown_district: "Bengaluru",
      godown_pincode: "234565432345",
      assigned_to: "43421",
      due_date: "12th Mar 2025",
      deliveryCode:'',
      products: [
        "BCALB0021",
        "NACAL9876"
      ],
      status: [
        {
          info: 'Request Submitted',
          status: 'active',
          last_updated : '2025-07-06',
        },
        {
          info: 'Under Review',
          status: 'pending',
          last_updated : '',
        },
        {
          info: 'Completed/Rejected',
          status: 'pending',
          last_updated : '',
        }
      ],
      remarks: "string"
    },
    {
      request_id: '76543',
      partner_id: '123456789',
      govt_application_number: "GOVT3456787654456",
      gst_number: "98765434567898765432",
      license_number: "LPC98765456789",
      license_issued_date: "2025-07-06",
      license_expiry_date: "2025-07-06",
      license_copy_url: "http://www.dj.com/doc/345678",
      shop_address: "#4, kormangala, 5th block, saa dreams layout",
      shop_district: "bengaluru",
      shop_pincode: "123456789098765",
      godown_same_as_shop: true,
      godown_address: "#4, kormangala, 5th block, saa dreams layout",
      godown_district: "Bengaluru",
      godown_pincode: "234565432345",
      assigned_to: "43421",
      due_date: "12th Mar 2025",
      deliveryCode:'',
      products: [
        "BCALB0021",
        "NACAL9876"
      ],
      status: [
        {
          info: 'Request Submitted',
          status: 'completed',
          last_updated : '2025-07-06',
        },
        {
          info: 'Under Review',
          status: 'completed',
          last_updated : '',
        },
        {
          info: 'Rejected',
          status: 'Rejected',
          last_updated : '',
        }
      ],
      remarks: "string"
    }
  ]

  export const configConstants = {
    countryCode: 'IN',
    USER_STATE: 'USER_STATE'
  }

export const userType = {
  RETAILER: 'retailer',
  DISTRIBUTOR: 'distributor',
  ISSUER: 'issuer',
}

  export const MH_CODE = '27';